import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton/IconButton';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useCompanyStore } from '../../../application/stores/company.store';
import { FormStatus } from '../../../contexts/FormProgressContext';
import { LOGO_HORZ, LOGO_HORZ_ENDOSO } from '../../../assets/images';
import { capitaliceWord } from '../../../utils/textUtils';
import MainMenu from '../MainMenu/MainMenu';
import MenuLanguages from '../MenuLanguages/MenuLanguages';
import ContactInfoModal from '../Modals/ContactInfo/ContactInfoModal';
import ContactInfoModalWithResetLink from '../Modals/ContactInfo/ContactInfoModalWithResetLink';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import TitlePage from '../TitlePage/TitlePage';
const Header = ({ titlePage, btnBack, urlBack }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { company } = useCompanyStore();
    const theme = useTheme();
    // Detecta si la pantalla es menor al breakpoint "sm"
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    //LANGUAGE
    const [anchorLanguage, setAnchorLanguage] = React.useState(null);
    const handleOpenLanguage = (event) => {
        setAnchorLanguage(event.currentTarget);
    };
    const handleCloseLanguage = () => {
        setAnchorLanguage(null);
    };
    //Menu general
    const [openDrawer, setOpenDrawer] = useState(false);
    const handleOpenDrawer = () => {
        setOpenDrawer(true);
    };
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    //NOTIFICATIONS
    //TODO Aqui supuestamente se actualizan las notificaciones
    /*   const { newNotifications, refreshNewNotifications } = useNewNotifications(); */
    const [notiPopover, setNotiPopover] = React.useState(null);
    const handleOpenNotiPopover = (event) => {
        setNotiPopover(event.currentTarget);
    };
    const handleCloseNotiPopover = () => {
        setNotiPopover(null);
    };
    return (_jsxs("div", Object.assign({ className: "PreHeader" }, { children: [_jsx("div", Object.assign({ className: 'header-wrapper' }, { children: _jsxs("header", Object.assign({ className: "container-xl header" }, { children: [_jsx(Link, Object.assign({ className: 'header-logo', to: "/" }, { children: _jsx("img", { alt: "SIGNO", src: isSmallScreen ? LOGO_HORZ : LOGO_HORZ_ENDOSO }) })), _jsxs("div", Object.assign({ className: "header-title" }, { children: [_jsx("h1", Object.assign({ className: "title" }, { children: t('common.title') })), _jsx("p", Object.assign({ className: "subtitle" }, { children: company.companyName }))] })), _jsxs("div", Object.assign({ className: "header-tools" }, { children: [_jsx(Tooltip, Object.assign({ title: "Idioma", placement: "top" }, { children: _jsxs(IconButton, Object.assign({ onClick: handleOpenLanguage, "aria-label": t('common.ariaLabels.languages') }, { children: [_jsx(LanguageOutlinedIcon, {}), _jsx("span", Object.assign({ className: "language-text" }, { children: capitaliceWord(i18n.language) }))] })) })), _jsx(Tooltip, Object.assign({ title: "Men\u00FA", placement: "top" }, { children: _jsx(IconButton, Object.assign({ onClick: handleOpenDrawer, "aria-label": 'Menú' }, { children: _jsx(MenuRoundedIcon, { fontSize: "small" }) })) })), _jsx(MenuLanguages, { anchorEl: anchorLanguage, onClose: handleCloseLanguage })] })), company.formStatus !== FormStatus.NOT_STARTED ? _jsx(ContactInfoModalWithResetLink, {}) : _jsx(ContactInfoModal, {})] })) })), titlePage && _jsx(TitlePage, { titlePage: titlePage, btnBack: btnBack, urlBack: urlBack }), _jsx(MainMenu, { openDrawer: openDrawer, handleCloseMenu: handleCloseDrawer })] })));
};
export default Header;
